// extracted by mini-css-extract-plugin
module.exports = {"lab__main":"lab-module--lab__main--u6NFl","bullet":"lab-module--bullet--3SsSu","page_titles":"lab-module--page_titles--1T3Se","lab__projects":"lab-module--lab__projects--nIqAq"};